import { ModulePackFE_BookDB, ModulePackFE_ClinicalFormDB, ModulePackFE_DiscussionDB, ModulePackFE_Expression, ModulePackFE_LogTemplateDB_OLD, ModulePackFE_MacroTag, ModulePackFE_MeasurementUnit, ModulePackFE_NLPDataDB, ModulePackFE_ReferenceDB, ModulePackFE_ResourceDB, ModulePackFE_ScoreDB, ModulePackFE_TagDB, ModulePackFE_Value, ModulePackFE_Variable, ModulePackFE_VariableRelation } from './_entity.js';
import { ModuleFE_Dictionary } from './dictionary/ModuleFE_Dictionary.js';
import { ModuleFE_HCSPermissions } from './permissions/index.js';
import { ModulePackFE_ContextRuleDB } from './_entity/context-rule/index.js';
export const ModulePackFE_HealthcareSpace = [
    ModuleFE_Dictionary,
    ModuleFE_HCSPermissions,
    ...ModulePackFE_DiscussionDB,
    ...ModulePackFE_VariableRelation,
    ...ModulePackFE_MeasurementUnit,
    ...ModulePackFE_Value,
    ...ModulePackFE_Variable,
    ...ModulePackFE_MacroTag,
    ...ModulePackFE_NLPDataDB,
    ...ModulePackFE_BookDB,
    ...ModulePackFE_ReferenceDB,
    ...ModulePackFE_TagDB,
    ...ModulePackFE_ClinicalFormDB,
    ...ModulePackFE_LogTemplateDB_OLD,
    ...ModulePackFE_ScoreDB,
    ...ModulePackFE_ContextRuleDB
];
export const ModulePackFE_HCS_SeparatePermissionDomainModules = [
    ...ModulePackFE_ResourceDB,
    ...ModulePackFE_Expression,
];
//# sourceMappingURL=module-pack.js.map